const EVENT_HELPER = {
  TEMPORARY_USER_TRAITS: 'temporary-user-traits',
}

const BUSINESS_VERTICAL = {
  GROCERY: 'grocery',
  FOOD: 'food',
  REWARD: 'reward',
}

const EVENT_CATEGORY = {
  GROCERY: 'grocery',
  PROMOTION_COLLECTION: 'promotion collection',
  VOUCHER: 'voucher',
  ACCOUNT: 'account',
  PAYMENT: 'payment',
  CHECKOUT: 'checkout',
  BANNER: 'banner',
  ADVERTISEMENT: 'advertisement',
}

const FULFILMENT_CHANNEL = {
  ONLINE: 'online',
  FINEST: 'finest',
  HYPERMARKET: 'hypermarket',
  SUPERMARKET_UNITY_CHEERS: 'supermarket, unity, cheers',
  KOPITIAM: 'kopitiam',
}

const CHECKOUT_FLOW = {
  E_COMMERCE: 'e-commerce',
}

const BUTTON_NAME = {
  MYINFO_CONTINUE: 'myinfo continue',
  POA_INITIATED: 'poa initiated',
  SWIMLANE_SEE_ALL: 'swimlane see all',
  PLACE_ORDER: 'place order',
  VOUCHER_ADD: 'voucher add',
  CHECKOUT: 'checkout',
  FIND_SIMILAR: 'find similar',
}
const ALGOLIA_EVENT_TYPE = {
  CLICK: 'click',
  VIEW: 'view',
}

const BUTTON_TYPE = {
  LINK_STYLE: 'link style',
}

export {
  EVENT_HELPER,
  BUSINESS_VERTICAL,
  EVENT_CATEGORY,
  FULFILMENT_CHANNEL,
  CHECKOUT_FLOW,
  BUTTON_NAME,
  BUTTON_TYPE,
  ALGOLIA_EVENT_TYPE,
}
